import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class CardStackRoute extends Route {
  @service("ember-store")
  store

  @service
  session

  model(params) {
    return this.store.find("card-stack", params.id)
  }
}
